import React, { useState } from 'react';
import { IoIosListBox } from 'react-icons/io';
import classnames from 'classnames';
import { useCheckout } from 'features/events/checkout/context';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { CheckoutSteps } from 'features/events/checkout/types';
import { useTranslation } from 'react-i18next';

type TierMenuProps = {
  activeSectionId: string;
  onClick: (sectionId: string) => void;
};

export default function TierMenu({ activeSectionId, onClick }: TierMenuProps) {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const {
    ticketTiers: { menuSections: allTierSections },
    addonTiers: { menuSections: addonSections },
    currentStep
  } = useCheckout();
  const { t } = useTranslation(['checkout']);
  const isAddonStep = currentStep === CheckoutSteps.TicketTiersAddon;
  const sections = isAddonStep ? addonSections : allTierSections;

  const handleFilterClick = () => {
    setIsFilterModalOpen(true);
  };

  const handleSectionClick = (sectionId: string) => {
    setIsFilterModalOpen(false);

    // Add a 0 timeout to make onClick run after the previous state change is complete
    setTimeout(() => {
      onClick(sectionId);
    }, 0);
  };

  const handleCloseFilterModal = () => {
    setIsFilterModalOpen(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleFilterClick}
        className="bg-white px-4 md:pl-2"
      >
        <img
          src="/img/icons/tier-navigation-filter.svg"
          alt={t('checkout:ticketTierCategoriesTitle')}
        />
      </button>
      <Modal
        noBodyLock
        type={ModalType.SMALL}
        onClose={handleCloseFilterModal}
        autoHeight
        visible={isFilterModalOpen}
        icon={<IoIosListBox size={20} className="text-[#3853C4]" />}
        title={t('checkout:ticketTierCategoriesTitle')}
      >
        <div className="h-full pb-24 md:pb-16 overflow-auto max-h-[95vh] md:max-h-[600px]">
          <div className="p-4 flex flex-col gap-2">
            {sections.map((section) => (
              <div key={section.id} className="flex">
                <button
                  type="button"
                  className="flex flex-1 gap-2 items-center h-[48px]"
                  onClick={() => handleSectionClick(section.id)}
                >
                  <p className="text-base font-normal text-neutral-900 text-left flex-1">
                    {section.name}
                  </p>
                  <div
                    className={classnames(
                      'w-[20px] h-[20px] bg-white border-2 border-neutral-900 rounded-full flex items-center justify-center',
                      {
                        'border-primary-500': section.id === activeSectionId
                      }
                    )}
                  >
                    {section.id === activeSectionId && (
                      <div
                        className={classnames(
                          'w-[10px] h-[10px] bg-primary-500 rounded-full'
                        )}
                      />
                    )}
                  </div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
}
